(function () {
  const root = document.getElementById('FreskyAssistant');
  if (!root) return;

  const storageKey = 'freskyClosedThisSession';
  const whatsappUrl = root.dataset.whatsappUrl;
  const pageType = root.dataset.pageType || 'page';
  const rootUrl = root.dataset.rootUrl || '/';
  const productTitle = root.dataset.productTitle || '';
  const productHandle = root.dataset.productHandle || '';
  const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const messages = root.querySelector('[data-fresky-messages]');
  const formShell = root.querySelector('[data-fresky-form-shell]');
  const requestForm = root.querySelector('#FreskyContactForm');
  const askForm = root.querySelector('[data-fresky-ask]');
  const askInput = askForm ? askForm.querySelector('input') : null;
  const statusNode = root.querySelector('[data-fresky-form-status]');
  let requestInFlight = false;

  const links = {
    box: `${rootUrl}collections/box-estratti`,
    mini: `${rootUrl}products/mini-box-6-estratti`,
    starter: `${rootUrl}products/starter-box`,
    box24: `${rootUrl}products/box-24-estratti`,
    family: `${rootUrl}products/box-48-estratti`,
    contact: `${rootUrl}pages/contact`,
    cart: `${rootUrl}cart`,
  };

  const copy = {
    open: 'Ciao, sono Fresky. Ti aiuto a scegliere la box giusta o a completare il tuo ordine?',
    choose: 'Ti aiuto io. Per quante persone stai acquistando? Vuoi provare Fresco o fare scorta?',
    shipping: 'Le spedizioni Fresco sono refrigerate. Appena ricevi la box, metti subito le bottiglie in frigorifero.',
    duration:
      "Da chiusi, gli estratti Fresco si conservano fino a 90 giorni in frigorifero, secondo la data indicata in etichetta. Dopo l'apertura, consigliamo di consumarli entro 24/48 ore.",
    cart: 'Mi dispiace per il problema. Posso aiutarti oppure metterti subito in contatto con un operatore Fresco su WhatsApp.',
    extractor:
      "Perfetto, Fresco nasce proprio per questo: frutta e verdura pronta da bere, senza usare l'estrattore, senza preparare nulla e senza pulire.",
    price:
      "Capisco. Ti consiglio di scegliere in base all'uso reale: la Mini Box 6 è perfetta per provare, mentre le box più grandi abbassano il prezzo per bottiglia e ti lasciano il frigo pronto più a lungo.",
    freshness:
      'È un dubbio giusto. Le spedizioni Fresco sono refrigerate e i prodotti vanno messi subito in frigorifero alla consegna.',
    payment: 'Sì, il pagamento avviene tramite checkout sicuro. Dopo l’ordine riceverai conferma e aggiornamenti sulla consegna.',
    default:
      'Ti aiuto volentieri. Fresco è pensato per chi vuole frutta e verdura pronta da bere, senza usare l’estrattore, senza preparare nulla e senza pulire.',
    requestSuccess: 'Grazie, abbiamo ricevuto la tua richiesta. Ti risponderemo il prima possibile.',
    requestError: 'Non siamo riusciti a inviare la richiesta. Puoi scriverci direttamente su WhatsApp.',
    consentError: 'Per ricontattarti via email o telefono devi accettare il consenso per questa richiesta.',
    messageError: 'Scrivi un messaggio prima di inviare la richiesta.',
  };

  function setState(state) {
    root.classList.remove('is-hidden', 'is-teaser', 'is-open', 'is-minimized');
    root.classList.add(`is-${state}`);
  }

  function showInitial() {
    if (window.sessionStorage.getItem(storageKey) === '1') {
      setState('minimized');
      return;
    }
    const delayMap = { product: 7000, cart: 5500, index: 9000 };
    const delay = reducedMotion ? 800 : delayMap[pageType] || 9500;
    window.setTimeout(() => {
      if (window.sessionStorage.getItem(storageKey) !== '1' && !root.classList.contains('is-open')) {
        setState('teaser');
      }
    }, delay);
  }

  function openPanel() {
    setState('open');
    scrollMessages();
  }

  function closePanel() {
    window.sessionStorage.setItem(storageKey, '1');
    setState('minimized');
  }

  function scrollMessages() {
    if (!messages) return;
    messages.scrollTop = messages.scrollHeight;
  }

  function addMessage(text, type = 'bot', actions = []) {
    if (!messages) return null;
    const item = document.createElement('div');
    item.className = `fresky__message fresky__message--${type}`;
    const p = document.createElement('p');
    p.textContent = text;
    item.appendChild(p);

    if (actions.length) {
      const actionWrap = document.createElement('div');
      actionWrap.className = 'fresky__inline-actions';
      actions.forEach((action) => {
        const node = action.href ? document.createElement('a') : document.createElement('button');
        node.textContent = action.label;
        if (action.href) {
          node.href = action.href;
          if (action.external) {
            node.target = '_blank';
            node.rel = 'noopener';
          }
        } else {
          node.type = 'button';
          node.addEventListener('click', action.onClick);
        }
        actionWrap.appendChild(node);
      });
      item.appendChild(actionWrap);
    }

    messages.appendChild(item);
    scrollMessages();
    return item;
  }

  function showForm() {
    if (!formShell) return;
    formShell.hidden = false;
    addMessage('Certo. Lasciami la richiesta: la inviamo direttamente al team Fresco.', 'bot');
    const field = formShell.querySelector('[data-fresky-message]');
    if (field) field.focus({ preventScroll: true });
    scrollMessages();
  }

  function recommendBox(kind) {
    const options = {
      mini: {
        text: 'Ti consiglio la Mini Box 6 se vuoi provare Fresco senza fare scorta. È la scelta più semplice per iniziare.',
        href: links.mini,
      },
      starter: {
        text: 'Ti consiglio la Starter Box 12 se vuoi iniziare una routine settimanale senza esagerare.',
        href: links.starter,
      },
      box24: {
        text: 'Ti consiglio la Box 24 se vuoi più varietà e il frigo pronto più a lungo. È una scelta molto equilibrata.',
        href: links.box24,
      },
      family: {
        text: 'Ti consiglio la Family Box 48 se acquisti per famiglia, ufficio o consumo costante. È la scelta più conveniente per bottiglia.',
        href: links.family,
      },
    };
    const option = options[kind] || options.starter;
    addMessage(`${option.text} Vuoi che ti porti direttamente alla box consigliata?`, 'bot', [
      { label: 'Vai alla box', href: option.href },
      { label: 'Vedi tutte le box', href: links.box },
    ]);
  }

  function handleAction(action) {
    openPanel();
    if (action === 'choose') {
      addMessage(copy.choose, 'bot', [
        { label: 'Provare', onClick: () => recommendBox('mini') },
        { label: 'Routine settimana', onClick: () => recommendBox('starter') },
        { label: 'Più varietà', onClick: () => recommendBox('box24') },
        { label: 'Famiglia o ufficio', onClick: () => recommendBox('family') },
      ]);
    }
    if (action === 'shipping') {
      addMessage(copy.shipping, 'bot', [
        { label: 'Consigliami una box', onClick: () => handleAction('choose') },
        { label: 'Vedi le box', href: links.box },
      ]);
    }
    if (action === 'duration') {
      addMessage(copy.duration, 'bot', [
        { label: 'Consigliami in base all’uso', onClick: () => handleAction('choose') },
      ]);
    }
    if (action === 'cart') {
      addMessage(copy.cart, 'bot', [
        { label: 'Lascia una richiesta', onClick: showForm },
        { label: 'Parla con operatore', href: whatsappUrl, external: true },
      ]);
    }
    if (action === 'request') showForm();
    if (action === 'operator') {
      addMessage('Certo, ti metto subito in contatto con un operatore Fresco su WhatsApp.', 'bot');
      window.open(whatsappUrl, '_blank', 'noopener');
    }
  }

  function answerFreeText(value) {
    const text = value.toLowerCase();
    addMessage(value, 'user');
    if (text.includes('estrattore') || text.includes('pulire') || text.includes('preparare')) {
      addMessage(`${copy.extractor} Vuoi che ti consigli la box migliore per iniziare?`, 'bot', [
        { label: 'Scegli box', onClick: () => handleAction('choose') },
      ]);
    } else if (text.includes('costa') || text.includes('prezzo') || text.includes('caro')) {
      addMessage(`${copy.price} Vuoi vedere la box più conveniente per te?`, 'bot', [
        { label: 'Vedi le box', href: links.box },
      ]);
    } else if (text.includes('fresc') || text.includes('spedizion') || text.includes('refriger')) {
      addMessage(`${copy.freshness} Vuoi che ti mostri la box più adatta per iniziare?`, 'bot', [
        { label: 'Scegli box', onClick: () => handleAction('choose') },
      ]);
    } else if (text.includes('pag') || text.includes('sicuro') || text.includes('checkout')) {
      addMessage(`${copy.payment} Vuoi che ti aiuti a completare l’ordine?`, 'bot', [
        { label: 'Vai al carrello', href: links.cart },
        { label: 'Parla con operatore', href: whatsappUrl, external: true },
      ]);
    } else {
      addMessage(`${copy.default} Vuoi che ti consigli la box più adatta?`, 'bot', [
        { label: 'Scegli box', onClick: () => handleAction('choose') },
        { label: 'Lascia richiesta', onClick: showForm },
      ]);
    }
  }

  async function cartSummary() {
    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('cart');
      const cart = await response.json();
      if (!cart.items || !cart.items.length) return 'Carrello vuoto';
      const items = cart.items.map((item) => `${item.quantity} × ${item.product_title || item.title}`).join(', ');
      return `${cart.item_count} articoli: ${items}`;
    } catch {
      return `${root.dataset.cartCount || 0} articoli (dettaglio non rilevabile)`;
    }
  }

  function setStatus(text, type) {
    if (!statusNode) return;
    statusNode.textContent = text;
    statusNode.classList.remove('is-error', 'is-success');
    if (type) statusNode.classList.add(`is-${type}`);
  }

  function buildRequestBody(values, cartText) {
    return [
      'Nuova richiesta ricevuta da Fresky.',
      '',
      'Nome cliente:',
      values.name || 'Non indicato',
      '',
      'Email cliente:',
      values.email || 'Non indicata',
      '',
      'Telefono cliente:',
      values.phone || 'Non indicato',
      '',
      'Messaggio:',
      values.message,
      '',
      'Pagina:',
      window.location.href,
      '',
      'Prodotto visualizzato:',
      productTitle ? `${productTitle}${productHandle ? ` (${productHandle})` : ''}` : 'Non rilevabile',
      '',
      'Carrello:',
      cartText,
      '',
      'Data e ora:',
      new Date().toLocaleString('it-IT'),
      '',
      'Fonte:',
      'Fresky Assistant',
    ].join('\n');
  }

  function hasSuccessSignal(response, html) {
    return response.url.includes('contact_posted=true') || html.includes('contact_posted=true') || html.includes('posted_successfully');
  }

  async function submitRequest(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    }
    if (!requestForm) return;
    if (requestInFlight) return;

    const name = (requestForm.querySelector('[data-fresky-name]')?.value || '').trim();
    const email = (requestForm.querySelector('[data-fresky-email]')?.value || '').trim();
    const phone = (requestForm.querySelector('[data-fresky-phone]')?.value || '').trim();
    const messageNode = requestForm.querySelector('[data-fresky-message]');
    const message = (messageNode?.value || '').trim();
    const consent = requestForm.querySelector('[data-fresky-consent]')?.checked || false;
    const submit = requestForm.querySelector('.fresky__submit');

    if (!message) {
      setStatus(copy.messageError, 'error');
      if (messageNode) messageNode.focus();
      return;
    }

    if ((email || phone) && !consent) {
      setStatus(copy.consentError, 'error');
      return;
    }

    const formData = new FormData(requestForm);
    const cartText = await cartSummary();
    formData.set('contact[subject]', 'Nuova richiesta da Fresky');
    formData.set('contact[email]', email || 'fresconaturalshop@gmail.com');
    formData.set('contact[body]', buildRequestBody({ name, email, phone, message }, cartText));

    setStatus('Invio in corso...', null);
    if (submit) submit.disabled = true;
    requestInFlight = true;

    try {
      const response = await fetch(requestForm.action, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
      });
      const html = await response.text();

      if (!response.ok || !hasSuccessSignal(response, html)) {
        throw new Error('contact_form_not_confirmed');
      }

      requestForm.reset();
      setStatus(copy.requestSuccess, 'success');
      addMessage(copy.requestSuccess, 'bot');
    } catch (error) {
      setStatus(copy.requestError, 'error');
      addMessage(copy.requestError, 'bot', [
        { label: 'Parla con operatore', href: whatsappUrl, external: true },
      ]);
    } finally {
      requestInFlight = false;
      if (submit) submit.disabled = false;
    }
  }

  root.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-fresky-open]');
    const closeButton = event.target.closest('[data-fresky-close]');
    const actionButton = event.target.closest('[data-fresky-action]');
    if (openButton) openPanel();
    if (closeButton) closePanel();
    if (actionButton) handleAction(actionButton.dataset.freskyAction);
  });

  if (askForm && askInput) {
    askForm.addEventListener('submit', (event) => {
      event.preventDefault();
      const value = askInput.value.trim();
      if (!value) return;
      askInput.value = '';
      answerFreeText(value);
    });
  }

  if (requestForm) {
    requestForm.addEventListener('submit', submitRequest, true);
    const submitButton = requestForm.querySelector('.fresky__submit');
    if (submitButton) submitButton.addEventListener('click', submitRequest, true);
  }

  showInitial();
})();
